import React from "react";
import Icon1 from "../icons/Icon";

import TFGPT1 from "./TFGPT1";
import TFGPTGrey from "./TFGPTGrey";

function SearchBarDocuments({
  orgData,
  options,
  value,
  setValue,
  onAction,
  placeholder = "Chercher",
  searchEvents = false,
  setSeachType,
}) {
  return (
    <div
      className={`bg-neutral-100
     
      } rounded-3xl  w-fit px-3 py-1 h-fit`}
    >
      <div className="flex flex-row gap-2 w-full items-center">
        <Icon1 icon_name="search" fill={"grey"}></Icon1>
        <TFGPTGrey
          options={options}
          placeholder={placeholder}
          inputValue={value}
          setInputValue={setValue}
          onAction={onAction}
          width={400}
          start_only={false}
          has_label={true}
        ></TFGPTGrey>
      </div>
    </div>
  );
}

export default SearchBarDocuments;
